import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export enum UpdateModalResult {
  Refresh,
}

@Component({
  selector: 'app-update-modal',
  templateUrl: './update-modal.component.html',
  styleUrls: ['./update-modal.component.scss'],
})
export class UpdateModalComponent {
  title = 'App Update Available';
  messages: string[] = [
    'An update for Bokamoso is available with new features and fixes!',
    "Click 'Reload' to reload the application and apply them immediately.",
    'To see what the new exciting updates are, navigate to the change log afterwards.',
  ];
  buttonText = 'Reload';
  icon: string | null = null;

  constructor(private activeModal: NgbActiveModal) {}

  refresh() {
    this.activeModal.close(UpdateModalResult.Refresh);
  }
}
